<div>
  <div class="form-group row">
    <label for="distributor" class="col-md-2 col-form-label">Distributor</label>
    <mat-select id="distributor" class="col-md-4" (selectionChange)="Distributor_Change($event)" [(value)]="SelectedDistributor">
      <mat-option *ngFor="let dist of Distributors" [value]="dist.CompanyId">
        {{dist.Company}}
      </mat-option>
    </mat-select>
  </div>
  <div>
    <table style="width:100%;">
      <tr>
        <th>User</th>
        <th>Page</th>
        <th>Activity</th>
        <th>Date</th>
      </tr>
      <ng-container *ngFor="let act of UserActivity">
        <tr>
          <td>{{act.User.Email}}</td>
          <td>{{act.Page}}</td>
          <td>{{act.Action}}</td>
          <td>{{act.TimeStamp}}</td>
        </tr>
      </ng-container>
      
    </table>
    <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
</div>
